<template>
  <div v-if="organization.id && organizationPlan.id">
    <div
      v-if="isLoading"
      class="d-flex justify-center align-center"
      style="height: 100vh;"
    >
      <v-progress-circular
        indeterminate
        color="#2661FF"
        size="80"
      ></v-progress-circular>
    </div>
    <div v-else>
      <v-card class="rounded-lg" flat>
        <v-card-title class="px-10 pt-10">
          Reporte de crecimiento
        </v-card-title>
        <v-card-text class="mt-4">
          <v-row>
            <v-col cols="12" lg="6">
              <div class="ml-12">
                <p class="subtitle-1 font-weight-bold text-color">
                  Seleccionar indicadores
                </p>
                <p class="body-2 text-color" style="max-width: 250px;">
                  Utiliza las siguientes variables para observar las
                  estadísticas en el cuadro.
                </p>
              </div>
              <div class="px-12 mt-4">
                <v-btn-toggle
                  v-model="selectedIndicator"
                  mandatory
                  color="deep-purple accent-3"
                >
                  <v-row>
                    <v-col cols="6">
                      <v-btn
                        class="rounded-lg pa-4"
                        depressed
                        outlined
                        color="#2661FF"
                        style="width: 200px;"
                      >
                        <v-icon color="#2661FF">shield</v-icon>
                        <span class="body-2 pl-2">Licencia</span>
                      </v-btn>
                    </v-col>
                    <v-col cols="6">
                      <v-btn
                        class="rounded-lg pa-4"
                        depressed
                        outlined
                        color="#2661FF"
                        style="width: 200px;"
                      >
                        <v-icon color="#2661FF">autorenew</v-icon>
                        <span class="body-2 pl-2">Automation</span>
                      </v-btn>
                    </v-col>
                    <v-col cols="6">
                      <v-btn
                        class="rounded-lg pa-4"
                        depressed
                        outlined
                        color="#2661FF"
                        style="width: 200px;"
                      >
                        <v-icon color="#2661FF">percent</v-icon>
                        <span class="body-2 pl-2">Fee</span>
                      </v-btn>
                    </v-col>
                    <v-col cols="6">
                      <v-btn
                        class="rounded-lg pa-4"
                        depressed
                        outlined
                        color="#2661FF"
                        style="width: 200px;"
                      >
                        <v-icon color="#2661FF">payments</v-icon>
                        <span class="body-2 pl-2">Total</span>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-btn-toggle>
              </div>
            </v-col>
            <v-col cols="12" lg="6">
              <v-card color="#EBF0FF" flat class="rounded-lg">
                <v-card-title class="body-2 text-color">
                  <span class="font-weight-medium">Compara organizaciónes</span>
                  <span class="caption font-weight-light ml-1">
                    (opcional)</span
                  >
                </v-card-title>
                <v-card-text>
                  <p class="text-color caption" style="max-width: 350px;">
                    Observa cómo se compara {{ organization.name }} con otra
                    organización utilizando cualquiera de las medidas del
                    indice.
                  </p>
                  <v-form ref="form" v-model="valid" lazy-validation>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          :value="organization.name"
                          readonly
                          outlined
                          hide-details
                          class="rounded-lg"
                          style="background-color: #FFF;"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        class="d-flex justify-center align-center"
                      >
                        <span>VS.</span>
                      </v-col>
                      <v-col cols="12">
                        <v-autocomplete
                          v-model="organizationToCompare"
                          :items="computedOrganizations"
                          item-text="name"
                          item-value="id"
                          outlined
                          hide-details
                          class="rounded-lg"
                          style="background-color: #FFF;"
                          clearable
                          @change="organizationToCompare = $event"
                          @click:clear="clear('organizationToCompare')"
                        >
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="4">
                        <v-btn class="rounded-lg" color="#2661FF" @click="">
                          <span class="white--text">
                            Comparar
                          </span>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { organizationService } from "@/services/organization.service";
export default {
  name: "OrganizationReportChart",
  data() {
    return {
      isLoading: false,
      selectedIndicator: null,
      valid: true,
      organizations: [],
      organizationToCompare: null
    };
  },
  async created() {
    try {
      this.isLoading = true;
      await this.getAllOrganizations();
    } catch (error) {
      console.log(error);
    } finally {
      this.isLoading = false;
    }
  },
  watch: {
    selectedIndicator() {}
  },
  computed: {
    ...mapState({
      organization: ({ organization: { organization } }) => organization,
      organizationPlan: ({ organization: { organizationPlan } }) =>
        organizationPlan
    }),
    computedOrganizations() {
      return this.organizations.filter(org => org.id !== this.organization.id);
    }
  },
  methods: {
    async getOrganizationReport() {},
    async getAllOrganizations() {
      try {
        const organizations = (await organizationService.getAllOrganizations())
          .data;
        this.organizations = organizations;
      } catch (error) {
        console.log(error);
      }
    },
    async clear(type) {
      this[type] = null;
      // Call method
    }
  }
};
</script>

<style lang="scss">
.text-color {
  color: #2661ff !important;
}
</style>
